import React, { Component } from 'react';
import CarouselView from 'react/views/carousel/CarouselView';

class SingleCarouselView extends Component {
	render() {
		return (
			<CarouselView {...this.props} slidesToShow={1} />
		);
	}
}

export default SingleCarouselView;



// WEBPACK FOOTER //
// ./src/react/views/carousel/SingleCarouselView.jsx